/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 05.11.17.
 */

import React from "react";
import PropTypes from "prop-types";
import QRCode from "qrcode.react";
import {t} from "../../trans";

class ShowQrCodeForm extends React.Component {
    static propTypes = {
        owner: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        authKey: PropTypes.string.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {

        let qrCode = this.makeQrCodeUrl(this.props.owner, this.props.email, this.props.authKey);

        // Format authKey to 4-digit groups:
        let authKey = this.props.authKey;
        if (authKey) authKey = authKey.replace(/(.{4})/g, "$1 ");
        return (
            <div>
                <ul>
                    <li>
                        {t("Install the Authenticator App:")}
                        <ul>
                            <li>{t("If you have Apple iPhone then") + " "}<a target="_blank" href="https://itunes.apple.com/app/google-authenticator/id388497605">{t("click here")}</a></li>
                            <li>{t("If you have Android phone then") + " "}<a target="_blank" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">{t("click here")}</a></li>
                        </ul>
                    </li>
                    <li>{t("In the App select") + " "}<b>{t("Set up account")}</b></li>
                    <li>{t("Choose") + " "}<b>{t("Scan barcode")}</b></li>
                </ul>
                <p className="alert text-center"><QRCode value={qrCode}/></p>
                <p>{t("If you can't scan it then in the App select") + " "}<b>{t("Manual entry")}</b>{" " + t("and enter manually:")}</p>
                <div>
                    <div className="row">
                        <h4 className="col-sm-3">{t("Account:")}</h4>
                        <div className="col-sm-9"><h4>{this.props.owner + ": " + this.props.email}</h4></div>
                    </div>
                    <div className="row">
                        <h3 className="col-sm-3">{t("Key:")}</h3>
                        <div className="col-sm-9"><h3 className="text-capitalize">{authKey}</h3></div>
                    </div>
                </div>
            </div>
        );
    }

    makeQrCodeUrl(owner, email, code) {
        let issuer = encodeURIComponent(owner);
        let account = encodeURIComponent(email);
        let secret = encodeURIComponent(code);
        return `otpauth://totp/${issuer}:${account}?secret=${secret}&issuer=${issuer}`;
    }
}

export default ShowQrCodeForm;
